import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LAccordion } from '../charitra/charitra.service';
import { GalleryVM } from '../gallary/gallary.service';
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class SthanService {

  constructor(private httpClient: HttpClient) { }

  get(input: string): Observable<SthanDetail> {
    return this.httpClient.get<SthanDetail>(Constants.sthan + input);
  }
}

export class SthanLocation
{
  villageid = 0;
  talukaid = 0;
  name = "";
  info = "";
  marathiname=  "";
  latitude = "";
  longitude = "";
  city = "";
  geoLocationDetails: GeoLocationDetail[] = []
}

export class GeoLocationDetail
{
  id = "";
  villageId = "";
  googleName = "";
  marathiName = "";
  latitude = "";
  longitude = "";
}

export class SthanDetail
{
  sthanLocation: SthanLocation = new SthanLocation();
  leelas: LAccordion[] = [];
  gallery: GalleryVM[] = [];
}